import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getQuestionnaireEvaluationAnswerList, getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { onValidVinData, onInvalidVinData, onVinUpdated, onVehicleInfoUpdated, onResetVehicleInfo, onFlyoutClicked, getSelectedInfoEntries, getVehicleInfoData } from "../../vehicleInfo";
import { getVehicleConfigurationAttributesRequestAction } from "../../vehicleConfigurationAttributes";
import { photoCaptureIntelligentUpdateOCRInfo, photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentVinDecodeComponent } from '../components';
import { getCapturedUploadPhotoFiles, getIntelligentPhotoOCRInfo, getIntelligentSequenceScreenName, getPhotoCaptureIsTermsAndConditionAccepted, getShouldAllowMitchellIntelligent, getShouldAllowVinDecode } from '../selectors';
const mapStateToProps = (state) => ({
    isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
    vehicleInfoData: getVehicleInfoData(state),
    selectedInfoEntries: getSelectedInfoEntries(state),
    questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
    sequenceScreenName: getIntelligentSequenceScreenName(state),
    shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
    shouldAllowVinDecode: getShouldAllowVinDecode(state),
    files: getCapturedUploadPhotoFiles(state) || [],
    ocrInfo: getIntelligentPhotoOCRInfo(state),
    answerList: getQuestionnaireEvaluationAnswerList(state)
});
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        onValidVinData,
        onInvalidVinData,
        onVinUpdated,
        onVehicleInfoUpdated,
        onResetVehicleInfo,
        photoCaptureIntelligentViewChangeAction,
        onFlyoutClicked,
        onViewChange: photoCaptureIntelligentViewChangeAction,
        onOcrVinUpdate: photoCaptureIntelligentUpdateOCRInfo,
        loadVehicleConfigurationAttributes: getVehicleConfigurationAttributesRequestAction
    }, dispatch);
};
const IntelligentVinDecodeComponentWrapper = (props) => React.createElement(IntelligentVinDecodeComponent, Object.assign({}, props));
export const ConnectedIntelligentVinDecodeComponent = connect(mapStateToProps, mapDispatchToProps)(IntelligentVinDecodeComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentVinDecodeComponent.js.map